module.exports = __webpack_public_path__ + "static/media/mt_ln_1.0bf74cfd.png";